import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { SitesBuilderBrizyGetDto } from "../dto";

@Injectable({
  providedIn: "root"
})
export class SitesBuilderService {
  private serviceUrl = "SitesBuilder";

  constructor(private api: ApiService) {}

  getTargetUrl(): Observable<SitesBuilderBrizyGetDto> {
    return this.api.get(`${this.serviceUrl}/brizy`);
  }
}
